
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eco-repair-score",
      function () {
        return require("private-next-pages/eco-repair-score.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eco-repair-score"])
      });
    }
  